module.exports = __webpack_public_path__ + "static/Thumbsup-3569805439b7a23af1349867b524200f.svg";